import React from 'react';
import ServiceManagement from '../components/services/ServiceManagement';

const ServicePage = () => {
  return <ServiceManagement />;
};

export default ServicePage;
